/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_UploadsInputs */

const en_home_v2_uploads = /** @type {(inputs: Home_V2_UploadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploads`)
};

const es_home_v2_uploads = /** @type {(inputs: Home_V2_UploadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subidas`)
};

/**
* | output |
* | --- |
* | "Uploads" |
*
* @param {Home_V2_UploadsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_uploads = /** @type {((inputs?: Home_V2_UploadsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_UploadsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_uploads(inputs)
	return en_home_v2_uploads(inputs)
});